<div class="container">
  <div class="offset-1 col-10">

    <div class=" content">
      <div class=" row">
        <div class=" col-12">
          <div class=" card card-chart">
            <div class=" card-header">
              <div class=" row">
                <div class=" col-sm-12 text-left">
                  <div class=" btn-group float-right">
                    <label [ngClass]="{'btn btn-sm btn-primary':true, 'selected':!newPortfolio.is_standalone}"
                           (click)="newPortfolio.is_standalone=false">Original</label>
                    <label [ngClass]="{'btn btn-sm btn-primary':true, 'selected':newPortfolio.is_standalone}"
                           (click)="newPortfolio.is_standalone=true">Standalone</label>
                  </div>

                  <h5 class=" card-category">My Portfolio</h5>
                  <h2 *ngIf="!newPortfolio.is_standalone" class=" card-title"><i class="fas fa-feather-alt fa-lg"></i>&nbsp;&nbsp;&nbsp; Select funds and define characteristics</h2>
                  <h2 *ngIf="newPortfolio.is_standalone" class=" card-title"><i class="fas fa-feather-alt fa-lg"></i>&nbsp;&nbsp;&nbsp; Create a standalone portfolio</h2>
                </div>
              </div>
            </div>

            <div [ngClass]="{'card-body':true, 'd-none':newPortfolio.is_standalone}">
              <!-- Fund selection -->

              <div class="row">
                <div class="offset-8 col-4 text-center card-text" style="font-style: italic">
                  Please make sure to upload at least 5 years of daily historical returns.
                </div>
                <div class="col-8">
                  <mat-form-field class="w-100">
                    <mat-label class="card-text">Select Funds</mat-label>
                    <mat-select [disabled]="disableActions" [formControl]="componentsForm" (ngModelChange)="onManagedComponentsChange()" multiple>
                      <mat-optgroup *ngIf="uploadedComponents.length>0" label="Uploaded">
                        <mat-option [selected]="true" *ngFor="let component of uploadedComponents" [value]="component">{{ component.name }}</mat-option>
                      </mat-optgroup>
                      <mat-optgroup *ngIf="productList.length>0" label="Products">
                        <mat-option *ngFor="let product of productList" [value]="product">{{ product.name }}</mat-option>
                      </mat-optgroup>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="col-1 text-center" style="line-height: 48px">
                  <span class="card-text">or</span>
                </div>
                <div class="col-3 text-left" style="line-height: 48px">
                  <input type="file" (change)="changeListener($event.target.files, 'components')" class="upload" accept="text/csv" hidden #componentsfile multiple>
                  <app-line-button [disabled]="disableActions" (click)="disableActions ? null : componentsfile.click()">Upload returns file</app-line-button>
                </div>
              </div>
              <div *ngIf="managedComponents.length>0" class="row">
                <div class="col-8">
                  <mat-form-field *ngIf="allBenchmarks" class="w-100">
                    <mat-label class="card-text">Select a Benchmark</mat-label>
                    <mat-select [disabled]="disableActions" [(value)]="benchmark" (selectionChange)="onBenchmarksChange()">
                    <!--<mat-select [disabled]="disableActions" [formControl]="benchmarkForm" (ngModelChange)="onBenchmarksChange()">-->
                      <mat-option *ngFor="let benchmark of allBenchmarks" [value]="benchmark" (click)="onSelectBenchmark(benchmark)">{{ benchmark.name }}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="col-1 text-center" style="line-height: 48px">
                  <span class="card-text">or</span>
                </div>
                <div class="col-3 text-left" style="line-height: 48px">
                  <input type="file" (change)="changeListener($event.target.files, 'benchmark')" class="upload" accept="text/csv" hidden #benchmarkfile>
                  <app-line-button [disabled]="disableActions" (click)="disableActions ? null : benchmarkfile.click()">Upload returns file</app-line-button>
                </div>
              </div>
              <!-- Fund selection -->
            </div>

            <div [ngClass]="{'card-body':true, 'd-none':!newPortfolio.is_standalone}">

              <div class="row mt-3">
                <div class="offset-1 col-6">
                  <mat-form-field class="w-100">
                    <mat-label class="card-text">Enter Portfolio name</mat-label>
                    <input matInput [(ngModel)]="newPortfolio.name" (input)="checkAlertPortfolioParameters()">
                  </mat-form-field>
                </div>
                <div class="col-5"></div>
              </div>

              <!-- Benchmark selection -->
              <div class="row">
                <div class="offset-1 col-6">
                  <mat-form-field *ngIf="allBenchmarks" class="w-100">
                    <mat-label class="card-text">Select a Benchmark</mat-label>
                    <mat-select [disabled]="disableActions" [(value)]="benchmark" (selectionChange)="onBenchmarksChange()">
                    <!--<mat-select [disabled]="disableActions" [formControl]="benchmarkForm" (ngModelChange)="onBenchmarksChange()">-->
                      <mat-option *ngFor="let benchmark of allBenchmarks" [value]="benchmark" (click)="onSelectBenchmark(benchmark)">{{ benchmark.name }}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="col-1 text-center" style="line-height: 48px">
                  <span class="card-text">or</span>
                </div>
                <div class="col-3 text-left" style="line-height: 48px">
                  <input type="file" (change)="changeListener($event.target.files, 'benchmark')" class="upload" accept="text/csv" hidden #benchmarkfile>
                  <app-line-button [disabled]="disableActions" (click)="disableActions ? null : benchmarkfile.click()">Upload returns file</app-line-button>
                </div>
              </div>
              <!-- Benchmark selection -->

              <div class="row mt-3">
                <div class="offset-1 col-10">
                  <div class="row">
                    <div class="col-6" style="line-height: 30px">
                      <div class="w-100" style="border-top:1px dotted grey"></div>
                      <span style="color: grey">
                        Investment Zone
                      </span>
                      <span class="float-right">
                        <mat-form-field *ngIf="investmentZoneList.length>0" class="w-100" style="margin-top:-20px; margin-bottom:-20px">
                          <mat-select [(value)]="newPortfolio.investment_zone">
                            <mat-option *ngFor="let zone of investmentZoneList" [value]="zone">{{zone.name}}</mat-option>
                          </mat-select>
                        </mat-form-field>
                      </span>
                    </div>
                    <div class="col-6" style="line-height: 30px">
                      <div class="w-100" style="border-top:1px dotted grey"></div>
                      <span style="color: grey">
                        AUM
                      </span>
                      <span class="float-right">
                        <mat-form-field class="w-100" style="margin-top:-20px; margin-bottom:-20px">
                          <input matInput type="number" min="0" [(ngModel)]="newPortfolio.aum" [step]="100000">
                        </mat-form-field>
                      </span>
                    </div>
                    <div class="col-6" style="line-height: 30px">
                      <span style="color: grey">
                        Market Positions
                      </span>
                      <span class="float-right">
                        <mat-form-field *ngIf="marketPositionsList.length>0 && newPortfolio.market_positions" class="w-100" style="margin-top:-20px; margin-bottom:-20px">
                          <mat-select [(value)]="newPortfolio.market_positions">
                            <mat-option *ngFor="let marketPositions of marketPositionsList" [value]="marketPositions">{{marketPositions.name}}</mat-option>
                          </mat-select>
                        </mat-form-field>
                      </span>
                      <div class="w-100" style="border-bottom:1px dotted grey; margin-top: -2px"></div>
                    </div>
                    <div class="col-6" style="line-height: 30px">
                      <span style="color: grey">
                        Type
                      </span>
                      <span class="float-right">
                        <mat-form-field *ngIf="assetTypeList.length>0 && newPortfolio.asset_type" class="w-100" style="margin-top:-20px; margin-bottom:-20px">
                          <mat-select [(value)]="newPortfolio.asset_type">
                            <mat-option *ngFor="let assetType of assetTypeList" [value]="assetType">{{assetType.name}}</mat-option>
                          </mat-select>
                        </mat-form-field>
                      </span>
                      <div class="w-100" style="border-bottom:1px dotted grey; margin-top: -2px"></div>
                    </div>
                  </div>
                </div>
              </div>

            </div>

            <div [ngClass]="{'card-footer':true, 'd-none':!newPortfolio.is_standalone}">
              <div class="row">
                <div class="col-12 text-center">
                  <app-button *ngIf="!standaloneCreated" [disabled]="disableActions" (click)="onUpload(true);">Upload in your Cloud</app-button>
                  <app-button *ngIf="standaloneCreated" [disabled]="disableActions" (click)="onGoToStrategyBuilder();">Go to strategy builder</app-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="!newPortfolio.is_standalone && managedComponents.length>0 && (step=='composition' || step=='portfolio' || step=='components' || step=='upload_cloud' || step=='summary')" class=" content">
        <br>
        <div class=" row">
          <div class=" col-12">
            <div class=" card card-chart">
              <div class=" card-header">
                <!-- Stepper -->
                <mat-horizontal-stepper *ngIf="!newPortfolio.is_standalone" linear style="background-color: transparent; margin-top: -10px;">
                  <ng-template matStepperIcon="edit">
                    <mat-icon>check</mat-icon>
                  </ng-template>
                  <mat-step>
                    <ng-template matStepLabel>Composition</ng-template>
                  </mat-step>
                  <mat-step>
                    <ng-template matStepLabel>Portfolio</ng-template>
                  </mat-step>
                  <mat-step *ngIf="selectedComponents.length>1">
                    <ng-template matStepLabel>Components</ng-template>
                  </mat-step>
                  <mat-step>
                    <ng-template matStepLabel>Upload in your cloud</ng-template>
                  </mat-step>
                  <mat-step>
                    <ng-template matStepLabel>Summary</ng-template>
                  </mat-step>
                </mat-horizontal-stepper>
                <!-- Stepper -->
              </div>

              <div class=" card-body">
                <!-- Composition step -->
                <div *ngIf="managedComponents.length>0 && step=='composition'">

                  <mat-radio-group [(ngModel)]="selectedPortfolio">
                    <mat-radio-button [value]="undefined" hidden class="unselectall" (click)="onUseAsPortfolio(undefined)"></mat-radio-button>
                    <table mdbTable small="true">
                      <thead>
                      <tr>
                        <th scope="col" class="card-text">Use as<br/>Portfolio</th>
                        <th scope="col" class="card-text">Ignore</th>
                        <th scope="col" class="card-text">Name</th>
                        <th scope="col" class="card-text">Benchmark</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr *ngFor="let managed of managedComponents">
                        <th class="text-center">
                          <mat-radio-button [value]="managed" small="true" style="border-color: white" (click)="onUseAsPortfolio(managed)"></mat-radio-button>
                        </th>
                        <th class="text-center">
                          <mat-checkbox [(ngModel)]="managed.ignore" (change)="onSelectedComponentsChange()" (change)="onIgnoreCheck(managed,$event)"></mat-checkbox>
                        </th>
                        <th>
                          <span>{{ managed.component.name }}</span>
                          <app-frequency-badge [frequency]="managed.component.frequency.alias"></app-frequency-badge>
                        </th>
                        <td>
                          <mat-form-field *ngIf="allBenchmarks" class="w-100" style="margin-top:-20px; margin-bottom:-20px">
                            <mat-select [(value)]="managed.component.benchmark" (selectionChange)="onComponentsBenchmarksChange()">
                              <mat-option [value]="undefined">Select a Benchmark</mat-option>
                              <mat-option *ngFor="let benchmark of allBenchmarks" [value]="benchmark">{{ benchmark.name }}</mat-option>
                            </mat-select>
                          </mat-form-field>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </mat-radio-group>
                </div>
                <!-- Composition step -->

                <!-- Portfolio step -->
                <div *ngIf="step=='portfolio'">

                  <div class="row">
                    <div class="offset-1 col-6">
                      <mat-form-field class="w-100">
                        <mat-label class="card-text">Enter Portfolio name</mat-label>
                        <input matInput [(ngModel)]="newPortfolio.name" (input)="checkAlertPortfolioParameters()">
                      </mat-form-field>
                    </div>

                    <div class="col-4">
                      <mat-form-field class="w-100">
                        <mat-label class="card-text">Enter Portfolio ticker</mat-label>
                        <input matInput [(ngModel)]="newPortfolio.ticker">
                      </mat-form-field>
                    </div>

                    <div class="offset-1 col-6">
                      <mat-form-field *ngIf="newPortfolio.benchmark" class="w-100">
                        <mat-label class="card-text">Selected Benchmark</mat-label>
                        <input matInput [value]="newPortfolio.benchmark.name" [disabled]="true">
                      </mat-form-field>
                    </div>
                  </div>

                  <div class="row mt-3">
                    <div class="offset-1 col-10">
                      <div class="row">
                        <div class="col-6" style="line-height: 30px">
                          <div class="w-100" style="border-top:1px dotted grey"></div>
                          <span style="color: grey">
                            Investment Zone
                          </span>
                          <span class="float-right">
                            <mat-form-field *ngIf="investmentZoneList.length>0" class="w-100" style="margin-top:-20px; margin-bottom:-20px">
                              <mat-select [(value)]="newPortfolio.investment_zone">
                                <mat-option *ngFor="let zone of investmentZoneList" [value]="zone">{{zone.name}}</mat-option>
                              </mat-select>
                            </mat-form-field>
                          </span>
                        </div>
                        <div class="col-6" style="line-height: 30px">
                          <div class="w-100" style="border-top:1px dotted grey"></div>
                          <span style="color: grey">
                            AUM
                          </span>
                          <span class="float-right">
                            <mat-form-field class="w-100" style="margin-top:-20px; margin-bottom:-20px">
                              <input matInput type="number" min="0" [(ngModel)]="newPortfolio.aum" [step]="100000">
                            </mat-form-field>
                          </span>
                        </div>
                        <div class="col-6" style="line-height: 30px">
                          <span style="color: grey">
                            Currency
                          </span>
                          <span class="float-right">
                            <mat-form-field *ngIf="currencyList.length>0 && newPortfolio.currency" class="w-100" style="margin-top:-20px; margin-bottom:-20px">
                              <mat-select [(value)]="newPortfolio.currency">
                                <mat-option *ngFor="let currency of currencyList" [value]="currency">{{currency.name}}</mat-option>
                              </mat-select>
                            </mat-form-field>
                          </span>
                        </div>
                        <div class="col-6" style="line-height: 30px">
                          <span style="color: grey">
                            Frequency
                          </span>
                          <span class="float-right">
                            <mat-form-field *ngIf="frequencyList.length>0 && newPortfolio.frequency" class="w-100" style="margin-top:-20px; margin-bottom:-20px">
                              <mat-select [(value)]="newPortfolio.frequency">
                                <mat-option *ngFor="let frequency of frequencyList" [value]="frequency">{{frequency.name}}</mat-option>
                              </mat-select>
                            </mat-form-field>
                          </span>
                        </div>
                        <div class="col-6" style="line-height: 30px">
                          <span style="color: grey">
                            Market Positions
                          </span>
                          <span class="float-right">
                            <mat-form-field *ngIf="marketPositionsList.length>0 && newPortfolio.market_positions" class="w-100" style="margin-top:-20px; margin-bottom:-20px">
                              <mat-select [(value)]="newPortfolio.market_positions">
                                <mat-option *ngFor="let marketPositions of marketPositionsList" [value]="marketPositions">{{marketPositions.name}}</mat-option>
                              </mat-select>
                            </mat-form-field>
                          </span>
                          <div class="w-100" style="border-bottom:1px dotted grey; margin-top: -2px;"></div>
                        </div>
                        <div class="col-6" style="line-height: 30px">
                          <span style="color: grey">
                            Type
                          </span>
                          <span class="float-right">
                            <mat-form-field *ngIf="assetTypeList.length>0 && newPortfolio.asset_type" class="w-100" style="margin-top:-20px; margin-bottom:-20px">
                              <mat-select [(value)]="newPortfolio.asset_type">
                                <mat-option *ngFor="let assetType of assetTypeList" [value]="assetType">{{assetType.name}}</mat-option>
                              </mat-select>
                            </mat-form-field>
                          </span>
                          <div class="w-100" style="border-bottom:1px dotted grey; margin-top: -2px;"></div>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
                <!-- Portfolio step -->

                <!-- Components step -->
                <div *ngIf="step=='components'">

                  <div class="col-12">
                    <table mdbTable small="true">
                      <thead>
                      <tr>
                        <th scope="col" class="card-text">Name</th>
                        <th scope="col" class="card-text">Weight</th>
                        <th scope="col" class="card-text">Investment Zone</th>
                        <th scope="col" class="card-text">Currency</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr *ngFor="let component of selectedComponents">
                        <th>
                          <span>{{ component.name }}</span>
                        </th>
                        <th style="width:80px">
                          <mat-form-field style="margin-top:-20px; margin-bottom:-20px; width:50px">
                            <input matInput type="number" [(ngModel)]="component.weight" (input)="checkAlertComponentsParameters()">
                          </mat-form-field>
                          %
                        </th>
                        <td>
                          <mat-form-field *ngIf="investmentZoneList.length>0" style="margin-top:-20px; margin-bottom:-20px; width:200px">
                            <mat-select [(value)]="component.investment_zone">
                              <mat-option *ngFor="let zone of investmentZoneList" [value]="zone">{{zone.name}}</mat-option>
                            </mat-select>
                          </mat-form-field>
                        </td>
                        <td>
                          <mat-form-field *ngIf="currencyList.length>0" style="margin-top:-20px; margin-bottom:-20px; width:50px">
                            <mat-select [(value)]="component.currency">
                              <mat-option *ngFor="let currency of currencyList" [value]="currency">{{currency.alias}}</mat-option>
                            </mat-select>
                          </mat-form-field>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>

                </div>
                <!-- Components step -->

                <!-- Upload in your cloud step -->
                <div *ngIf="step=='upload_cloud'">

                  <div class="col-12" style="font-size: small">
                    <div class="row">
                      <div class="col-12 text-center">
                        <app-title [title]="newPortfolio.name" priority="4" [uppercase]="false"></app-title>
                      </div>
                      <div class="col-6" style="line-height: 30px">
                        <div class="w-100" style="border-top:1px dotted grey"></div>
                        <span style="color: grey">
                          Benchmark
                        </span>
                        <span class="float-right">
                          {{ newPortfolio.benchmark.name }}
                        </span>
                      </div>
                      <div class="col-6" style="line-height: 30px">
                        <div class="w-100" style="border-top:1px dotted grey"></div>
                        <span style="color: grey">
                          Ticker
                        </span>
                        <span class="float-right">
                          {{ newPortfolio.ticker }}
                        </span>
                      </div>
                      <div class="col-6" style="line-height: 30px">
                        <span style="color: grey">
                          Investment zone
                        </span>
                        <span *ngIf="newPortfolio.investment_zone" class="float-right">
                          {{ newPortfolio.investment_zone.name }}
                        </span>
                      </div>
                      <div class="col-6" style="line-height: 30px">
                        <span style="color: grey">
                          Components
                        </span>
                        <span class="float-right">
                          {{ selectedComponents.length }}
                        </span>
                      </div>
                      <div class="col-6" style="line-height: 30px">
                        <span style="color: grey">
                          Frequency
                        </span>
                        <span class="float-right">
                          {{ newPortfolio.frequency.name }}
                        </span>
                      </div>
                      <div class="col-6" style="line-height: 30px">
                        <span style="color: grey">
                          Asset Type
                        </span>
                        <span *ngIf="newPortfolio.asset_type" class="float-right">
                          {{ newPortfolio.asset_type.name }}
                        </span>
                      </div>
                      <div class="col-6" style="line-height: 30px">
                        <span style="color: grey">
                          Currency
                        </span>
                        <span *ngIf="currencyList.length>0" class="float-right">
                          {{ newPortfolio.currency.name }}
                        </span>
                        <div class="w-100" style="border-bottom:1px dotted grey"></div>
                      </div>
                      <div class="col-6" style="line-height: 30px">
                        <span style="color: grey">
                          Market positions
                        </span>
                        <span *ngIf="newPortfolio.market_positions" class="float-right">
                          {{ newPortfolio.market_positions.name }}
                        </span>
                        <div class="w-100" style="border-bottom:1px dotted grey"></div>
                      </div>
                    </div>
                  </div>

                </div>
                <!-- Upload in your cloud step -->

                <!-- Summary step -->
                <div *ngIf="step=='summary'">

                  <div class="col-12" style="font-size: small">
                    <div class="row">
                      <div class="col-12 text-center">
                        <app-title [title]="newPortfolio.name" priority="4" [uppercase]="false"></app-title>
                      </div>
                      <div class="col-6" style="line-height: 30px">
                        <div class="w-100" style="border-top:1px dotted rgb(129,186,241)"></div>
                        <span style="color: grey">
                          Benchmark
                        </span>
                        <span class="float-right">
                          {{ newPortfolio.benchmark.name }}
                        </span>
                      </div>
                      <div class="col-6" style="line-height: 30px">
                        <div class="w-100" style="border-top:1px dotted rgb(129,186,241)"></div>
                        <span style="color: grey">
                          Ticker
                        </span>
                        <span class="float-right">
                          {{ newPortfolio.ticker }}
                        </span>
                      </div>
                      <div class="col-6" style="line-height: 30px">
                        <span style="color: grey">
                          Investment zone
                        </span>
                        <span *ngIf="newPortfolio.investment_zone" class="float-right">
                          {{ newPortfolio.investment_zone.name }}
                        </span>
                      </div>
                      <div class="col-6" style="line-height: 30px">
                        <span style="color: grey">
                          Components
                        </span>
                        <span class="float-right">
                          {{ selectedComponents.length }}
                        </span>
                      </div>
                      <div class="col-6" style="line-height: 30px">
                        <span style="color: grey">
                          Frequency
                        </span>
                        <span class="float-right">
                          {{ newPortfolio.frequency.name }}
                        </span>
                      </div>
                      <div class="col-6" style="line-height: 30px">
                        <span style="color: grey">
                          Asset Type
                        </span>
                        <span *ngIf="newPortfolio.asset_type" class="float-right">
                          {{ newPortfolio.asset_type.name }}
                        </span>
                      </div>
                      <div class="col-6" style="line-height: 30px">
                        <span style="color: grey">
                          Currency
                        </span>
                        <span *ngIf="currencyList.length>0" class="float-right">
                          {{ newPortfolio.currency.name }}
                        </span>
                        <div class="w-100" style="border-bottom:1px dotted rgb(129,186,241)"></div>
                      </div>
                      <div class="col-6" style="line-height: 30px">
                        <span style="color: grey">
                          Market positions
                        </span>
                        <span *ngIf="newPortfolio.market_positions" class="float-right">
                          {{ newPortfolio.market_positions.name }}
                        </span>
                        <div class="w-100" style="border-bottom:1px dotted rgb(129,186,241)"></div>
                      </div>
                    </div>
                  </div>

                </div>
                <!-- Summary step -->
              </div>

              <div class=" card-footer">
                <!-- Composition step -->
                <div *ngIf="managedComponents.length>0 && step=='composition'">
                  <div class="col-12 text-center">
                    <app-button color="light" [disabled]="disableNextComposition" (click)="onNext()">Next</app-button>
                  </div>
                </div>
                <!-- Composition step -->

                <!-- Portfolio step -->
                <div *ngIf="step=='portfolio'">
                  <div class="row">
                    <div class="col-12 text-center">
                      <app-button color="light" (click)="onBack()">Back</app-button>
                      <app-button color="light" [disabled]="disableNextComposition || newPortfolio.name==undefined || newPortfolio.name==''" (click)="onNext()">Next</app-button>
                    </div>
                  </div>
                </div>
                <!-- Portfolio step -->

                <!-- Components step -->
                <div *ngIf="step=='components'">
                  <div class="col-12 text-center">
                    <app-button color="light" (click)="onBack()">Back</app-button>
                    <app-button color="light" (click)="onNext()">Next</app-button>
                  </div>
                </div>
                <!-- Components step -->

                <!-- Upload in your cloud step -->
                <div *ngIf="step=='upload_cloud'">
                  <div class="row">
                    <div class="col-12 text-center">
                      <app-button color="light" [disabled]="disableActions" (click)="onBack()">Back</app-button>
                      <app-button [disabled]="disableActions" (click)="onUpload(false);">Upload in your Cloud</app-button>
                    </div>
                  </div>
                </div>
                <!-- Upload in your cloud step -->

                <!-- Summary step -->
                <div *ngIf="step=='summary'">
                  <div class="row">
                    <div class="col-12 text-center">
                      <app-button (click)="onSeeAnalytics();">See Analytics</app-button>
                    </div>
                  </div>
                </div>
                <!-- Summary step -->

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <br>
  </div>
</div>
